'use strict'

import CognitoService from './lib/CognitoService'

export default {
  install (Vue, options) {
    // check if this required configuration values have been passed
    const requiredEnv = ['COGNITO_POOL_ID', 'COGNITO_CLIENT_ID']
    requiredEnv.forEach((key) => {
      if (!options[key]) {
        throw new Error(`Cognito Plugin requires ${key} key to be passed via Plugin options`)
      }
    })

    // expose some Cognito functions to the app
    const { COGNITO_POOL_ID, COGNITO_CLIENT_ID } = options
    const cognito = CognitoService(COGNITO_POOL_ID, COGNITO_CLIENT_ID)
    Vue.prototype.$cognito = cognito
  }
}
